import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { sessionVerificationQueryOptions } from "@/app/user-verification/api/get-session-verification";
import { UserVerificationSkeleton } from "@/app/user-verification/components";
import { UserVerification } from "@/app/user-verification/list";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/settings/user-verification"
)({
  component: () => (
    <Suspense fallback={<UserVerificationSkeleton />}>
      <UserVerification />
    </Suspense>
  ),
  beforeLoad: (ctx) =>
    requireProjectPermission(ctx, PROJECT.securitySettings.read),
  loader: ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(
      sessionVerificationQueryOptions({ binding: "project", scope: params })
    );
    return { crumb: "User Verification" };
  },
});
